import { render } from "./ArticleManagement.vue?vue&type=template&id=0c69c814&scoped=true"
import script from "./ArticleManagement.vue?vue&type=script&lang=js"
export * from "./ArticleManagement.vue?vue&type=script&lang=js"

import "./ArticleManagement.vue?vue&type=style&index=0&id=0c69c814&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c69c814"]])

export default __exports__